<template>
    <div class="footer-wrapper">
        <div class="footer-header">
            <draggable class="navbar" :list="items" @end="onDragEnd">
                <a
                    v-if="item.permission"
                    v-for="(item, id) in items"
                    v-b-tooltip.hover
                    :title="item.title"
                    :class="[item.class, { active: id === active }]"
                    @click="currentComponent(item, id)"
                    :key="item.order"
                >
                    <font-awesome-icon fixed-width :icon="item.icon" />
                    <!-- <i :class="item.icon"></i> -->
                    <small>{{ item.text }}</small>
                </a>
            </draggable>

            <div class="stage">
                <span
                    class="badge badge-info"
                    v-bind:class="{ 'badge-danger': teamName == 'No Team', 'badge-info': teamName != 'No Team' }"
                    v-if="teamName && !isReferrer"
                    v-b-tooltip.hover
                    title="Application Team"
                >
                    {{ teamName }}
                </span>

                <router-link :to="{ name: currentStageName() }">
                    <span
                        class="badge"
                        @click="close()"
                        v-bind:class="{ 'badge-success': thisStage }"
                        v-if="thisStage"
                        v-b-tooltip.hover
                        title="Current Stage"
                    >
                        {{ thisStage.label }}
                    </span>
                </router-link>

                <span
                    class="badge"
                    v-bind:class="{ 'badge-success-dark': openStatus, 'badge-danger': !openStatus }"
                    v-b-tooltip.hover
                    :title="openStatus ? 'Close Application' : 'Reopen Application'"
                    @click="openStatus ? closeApplicationModalOpen() : reopen()"
                >
                    <font-awesome-icon :icon="['fas', 'unlock']" v-if="openStatus" />
                    <font-awesome-icon :icon="['fas', 'lock']" v-if="!openStatus" />
                </span>

                <div
                    id="footer-toolbar-app-ref"
                    class="app-ref d-none d-lg-flex"
                    v-if="applicantInfo && applicantInfo.first_name"
                >
                    <span class="mr-3 can-hide assigned-to">
                        <strong class="mr-1" v-if="brokerLabel">Assigned To:</strong>
                        {{ brokerLabel || "" }}
                    </span>
                    <span class="mr-3 can-hide application">
                        <strong class="mr-1">#{{ application.ref_id }}:</strong>
                        {{ applicantInfo.first_name || "" }} {{ applicantInfo.last_name || "" }}
                    </span>
                    <span class="mr-0 naf">
                        <!-- <strong class="mr-1">NAF: </strong> -->
                        <strong class="mr-1">Amount to Finance:</strong>
                        ${{ financeDetails.amountToFinanced || "0" }}
                        <!-- ${{ application.amount_to_financed || '0'}} -->
                    </span>

                    <!-- Application Reference Data Tooltip -->
                    <b-tooltip
                        v-if="referenceData"
                        :show.sync="showReferenceData"
                        :noninteractive="false"
                        triggers-OFF="manual"
                        target="footer-toolbar-app-ref"
                        placement="top"
                        custom-class="footer-app-ref-tooltip"
                    >
                        <div v-for="(e, i) in referenceData" :key="i" class="row">
                            <div class="mr-2 text-left col font-weight-bold">{{ e.label }}:</div>
                            <div class="text-right col">{{ e.value }}</div>
                        </div>
                    </b-tooltip>
                </div>

                <!-- Save Button -->
                <span class="pl-0 d-inline-block" v-if="canControlApp">
                    <!-- .badge-ambition-dark -->
                    <!-- <span

                        class="badge"
                        v-bind:class="[saved ? 'badge-wait disabled' : 'badge-ambition', disableSave ? 'disabled' : '']"
                        :style="{ color: '#fff', width: '110px' }"
                    >
                        {{ disableSave ? savingText : "Save Now" }}
                    </span> -->

                    <el-button
                        v-if="!isReferrer"
                        @click="saveApplication"
                        style="border-radius: 0"
                        :class="[saving ? 'badge-wait' : 'badge-ambition']"
                        :disabled="buttonDisabled || forceButtonDisabled || (appCompleted && !canEditCompleted)"
                        :loading="saving"
                    >
                        {{ buttonText }}
                    </el-button>
                </span>

                <el-tooltip v-else class="item" effect="dark"  placement="top">
                    <span @click="takeControl()" class="pl-0 d-inline-block">
                        <span class="badge" :style="{ color: '#fff', width: '110px', background: '#f78f53' }">Take Control</span>
                    </span>

                    <div slot="content">
                        <div>
                            Current Control: <strong>{{ currentEditUser }}</strong>
                        </div>
                        <div v-if="initAppData.fast_track_active">
                            Remaining Time: <countdown
                                :key="initAppData.fast_track_active"
                                :start-time="$moment.utc().format()"
                                :end-time="$moment.utc(initAppData.fast_track_active).format()"
                                @finish="allowTakeControl"
                            >
                                <template v-slot:process="scope">
                                    <strong>
                                        {{ `${scope.timeObj.m}:${scope.timeObj.s}` }}
                                    </strong>
                                </template>
                                <template v-slot:finish>
                                    <strong>Finished</strong>
                                </template>
                            </countdown>
                        </div>
                        <div v-if="initAppData.fast_track_active">
                            Last Save: <strong>{{ $moment.utc(initAppData.fast_track_last_save).fromNow() }}</strong>
                        </div>
                    </div>
                </el-tooltip>
            </div>

            <div>
                <button
                    class="mr-2 btn-green"
                    style="border-radius: 0"
                    @click="$bus.$emit('referrer-submit-broker')"
                    :disabled="isRefAppSubmitted"
                    v-if="isReferrer && !initAppData.is_submitted"
                >
                    {{ 'Save & Transfer' }}
                </button>
            </div>

            <keep-alive>
                <scratch-pad v-bind:class="{ show: show }" class="d-block"></scratch-pad>
            </keep-alive>

            <div class="actions" v-bind:class="{ show: show }">
                <a @click="fullscreen()">
                    <font-awesome-icon :icon="['fas', 'compress']" v-if="showFullscreen" />
                    <font-awesome-icon :icon="['fas', 'expand']" v-if="!showFullscreen" />
                </a>
                <a @click="close()"><i class="far fa-times-circle"></i></a>
            </div>
        </div>
        <div class="drawer" v-bind:class="{ show: show, 'show-fullscreen': showFullscreen }">
            <keep-alive>
                <component v-bind:is="currentTabComponent" v-bind="currentTabProps"></component>
            </keep-alive>
        </div>

        <close-application-modal :visible.sync="closeApplicationModalVisibility"></close-application-modal>

        <x-modal
            :wWidth="650"
            v-if="closeModal == true"
            @cancel="closeModal = false"
            @close="closeModal = false"
            @ok="closeApplication"
            :draggable="true"
            :resizable="true"
            :loading="closeAppSubmitted"
            :okDisabled="awaitingCloseReason"
            okText="Close Application"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Close Application</div>

            <div class="container py-4">
                <div class="pt-0 row amb-modal-body">
                    <div class="col-6 d-flex align-items-center">Reason for Closing:</div>
                    <div class="col-6">
                        <application-select
                            @input="checkReasonSelected"
                            class="select-belt"
                            :options="closeReasonsOptions"
                            v-model="closeReason"
                            default-option
                            default-label="Select Close Reason"
                        ></application-select>
                    </div>
                </div>
            </div>
        </x-modal>

        <x-modal
            :wWidth="600"
            v-if="appFormUserControlModal.visible"
            @cancel="confirmAppFormAction"
            @close="confirmAppFormAction"
            @ok="confirmAppFormAction"
            :draggable="true"
            :resizable="true"
            :loading="false"
            :okDisabled="false"
            :hideCancel="true"
            okText="Ok"
        >
            <div slot="title" class="fin-flex fin-items-center fin-justify-between">
                {{ _.startCase(_.toLower(application.fast_track_form)) }}
                Application has {{ _.startCase(_.toLower(appFormUserControlModal.stage)) }}
            </div>

            <div v-if="appFormUserControlModal.stage == 'started'">
                The Applicant has {{ appFormUserControlModal.stage }} the
                {{ _.startCase(_.toLower(application.fast_track_form)) }} Application. The application is now locked and
                no further changes will be saved.
            </div>

            <div v-if="appFormUserControlModal.stage == 'finished'">
                The Applicant has {{ appFormUserControlModal.stage }} the
                {{ _.startCase(_.toLower(application.fast_track_form)) }}
                Application. The browser will now reload to load the latest changes.
            </div>

            <div v-if="appFormUserControlModal.stage == 'timed out'">
                The App Form timer has expired and the application has been given back to {{ _.get(application, 'broker.full_name', 'no one') }}. The browser will now reload to load the latest changes.
            </div>
        </x-modal>

        <x-modal
            :wWidth="600"
            v-if="takeControlAppFormModal.visible"
            @cancel="takeControlAppFormModal.visible = false"
            @close="takeControlAppFormModal.visible = false"
            @ok="confirmAppFormTakeover"
            :draggable="true"
            :resizable="true"
            :loading="false"
            :okDisabled="false"
            :hideCancel="false"
            okText="Ok"
        >
            <div slot="title" class="fin-flex fin-items-center fin-justify-between">
                Take control of application
            </div>

            <div v-if="appFormFinished">
                {{ currentEditUser }} currently has control of this application but the timer is finished. You may take control of this application but the applicant may continue the application. If you continue, the application will reload to populate the latest data.
            </div>

            <div v-else>
                {{ currentEditUser }} currently has control of this application. If you take control now you run the risk of data being overwritten. The application will reload to populate the latest data. Are you sure you want to continue?
            </div>
        </x-modal>
    </div>
</template>
<script src="@ambition/components/application-steps/scripts/application.js"></script>
<script>
import { mapGetters } from "vuex"
import Tasks from "@ambition/components/tasks/Tasks"
import Notes from "@ambition/components/application-steps/Notes"
import Journal from "@ambition/components/application-steps/Journal"
import CallReports from "@shared/components/3cx/CallReports"
import SMSHub from "@ambition/components/application-steps/SMSHub"
import InboundQueue from "@ambition/components/application-steps/InboundQueue"
import History from "@ambition/components/application-steps/History"
import Conditioning from "@ambition/components/application-steps/Conditioning"
import ScratchPad from "@ambition/components/ScratchPad"
import PDFViewer from "@shared/components/pdf/PDFViewer"
import { GlobalEventBus } from "@tenant/shared/GlobalEventBus"
import closeApplicationModal from "@ambition/components/closeApplication/closeApplicationModal"
import VideoChat from "@shared/components/video/VideoChat"
import vueAwesomeCountdown from "vue-awesome-countdown"

import draggable from "vuedraggable"

export default {
    name: "footer-toolbar",
    components: {
        Notes,
        Journal,
        CallReports,
        SMSHub,
        InboundQueue,
        Tasks,
        History,
        Conditioning,
        ScratchPad,
        PDFViewer,
        closeApplicationModal,
        draggable,
        VideoChat,
        vueAwesomeCountdown,
    },
    props: {
        application: {
            type: Object,
            required: true,
        },
        canQuote: {
            type: Number,
            required: false,
            default: 0,
        },
        isReferrer: {
            type: Number,
            required: false,
            default: 0,
        },
        isBroker: {
            type: String,
            required: false,
            default: "1",
        },
        enableSmsHub: {
            type: String,
            required: false,
            default: "0",
        },
        enableDocumentHub: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    data() {
        return {
            appFormFinished: false,
            takeControlAppFormModal: {
                visible: false,
            },
            appFormUserControlModal: {
                visible: false,
                data: null,
                stage: null,
            },
            forceButtonDisabled: false,
            buttonText: "Save Now",
            buttonDisabled: true,
            saving: false,
            closeApplicationModalVisibility: false,
            active: null,
            closeModal: false,
            closeReasonsOptions: [],
            closeReason: "",
            closeAppSubmitted: false,
            awaitingCloseReason: true,
            isopen: true,
            showDocumentGenerator: false,
            documents: [],
            applicantInfo: null,
            items: [
                {
                    id: 0,
                    title: "Tasks",
                    icon: "tasks",
                    order: 1,
                    text: "Tasks",
                    class: "",
                    permission: !this.isReferrer,
                    component: "Tasks",
                    props: {
                        token: this.$store.getters.token,
                        applicationId: this.application.id,
                        showAllTasks: true,
                    },
                },
                {
                    id: 1,
                    title: "Notes",
                    text: "Notes",
                    order: 2,
                    icon: "sticky-note",
                    class: "",
                    permission: true,
                    component: "Notes",
                },
                {
                    id: 2,
                    title: "Call Log",
                    text: "Calls",
                    order: 3,
                    icon: "phone",
                    class: "",
                    permission: !this.isReferrer,
                    component: Ambition.getGlobal("tenant.pbx_active") && !Ambition.getGlobal("tenant.pbx_external") ? "CallReports" : "Journal",
                    props: {
                        headers: this.headers(),
                        applicationId: this.application.id,
                    },
                },
                {
                    id: 3,
                    title: "SMS Hub",
                    text: "SMS",
                    order: 4,
                    icon: "sms",
                    class: "",
                    permission: !this.isReferrer && this.enableSmsHub == 1,
                    component: "SMSHub",
                },
                {
                    id: 4,
                    title: "Email Queue",
                    text: "Mail",
                    order: 5,
                    icon: "inbox",
                    class: "",
                    permission: !this.isReferrer,
                    component: "InboundQueue",
                },
                {
                    id: 5,
                    title: "Event History",
                    text: "History",
                    order: 6,
                    icon: "history",
                    class: "",
                    permission: !this.isReferrer,
                    component: "History",
                },
                {
                    id: 6,
                    title: "Documents",
                    text: "Docs",
                    order: 7,
                    icon: "paste",
                    class: "",
                    permission: this.enableDocumentHub,
                    component: "Conditioning",
                },
                {
                    id: 7,
                    title: "Merge & Markup",
                    text: "Markup",
                    order: 8,
                    icon: "file-pdf",
                    class: "",
                    permission: !this.isReferrer,
                    component: "PDFViewer",
                    props: {
                        ...this.$props,
                    },
                },
                {
                    id: 8,
                    title: "Ambition Support",
                    text: "Help",
                    order: 9,
                    icon: "life-ring",
                    class: "text-danger",
                    component: "",
                },
                {
                    id: 9,
                    title: "Video Chat",
                    text: "Video",
                    order: 10,
                    icon: "video",
                    class: "",
                    // component: "VideoChat",
                    permission: Ambition.getGlobal("tenant.enableVideoCall") && !this.isReferrer,
                    // props: {
                    //     tenant: Ambition.getGlobal("tenant.tenantId"),
                    //     authuserid: Ambition.getGlobal("tenant.userId"),
                    //     turn_url: Ambition.getGlobal("tenant.turnUrl"),
                    //     turn_username: Ambition.getGlobal("tenant.turnUsername"),
                    //     turn_credential: Ambition.getGlobal("tenant.turnCredentials"),
                    //     application: this.$store.getters.initAppData,
                    //     authCheck: true
                    // }
                },
            ],
            currentTabComponent: "",
            currentTabProps: "",
            show: false,
            // status: "",
            showFullscreen: true,
            statuses: [
                { status: 0, label: "New", index: 0 },
                { status: 0, label: "Application Taken", index: 1 },
                { status: 0, label: "Documents Received", index: 2 },
                { status: 0, label: "Submitted to Lender", index: 3 },
                { status: 0, label: "Conditionally Approved", index: 4 },
                { status: 0, label: "Invoice Requested", index: 5 },
                { status: 0, label: "Invoice Returned", index: 6 },
                { status: 0, label: "Loan Package Sent", index: 7 },
                { status: 0, label: "Loan Package Received", index: 8 },
                { status: 0, label: "Loan Re-Submitted", index: 9 },
                { status: 0, label: "Loan Re-Approved", index: 10 },
                { status: 0, label: "Contracts Sent", index: 11 },
                { status: 0, label: "In for Settlement", index: 12 },
                { status: 0, label: "Settled", index: 13 },
                { status: 0, label: "Completed", index: 14 },
            ],

            // Application Reference Data
            showReferenceData: false,
            sortingArray: [
                { id: 0, order: 1 },
                { id: 1, order: 2 },
                { id: 2, order: 3 },
                { id: 3, order: 4 },
                { id: 4, order: 5 },
                { id: 5, order: 6 },
                { id: 6, order: 7 },
                { id: 7, order: 8 },
                { id: 8, order: 9 },
                { id: 9, order: 10 },
            ],
        }
    },
    mounted() {
        this.isRefAppSubmitted = this.$store.getters['referrer/appSubmitted']

        this.appFormFinished = !this.initAppData.fast_track_active ? true : false

        Echo.private(`app-form.${Ambition.tenantId()}.${this.application.id}`)
            .listen(".started", (event) => {
                _.set(this.initAppData, 'fast_track_active', event.fastTrackActive)
                _.set(this.initAppData, 'fast_track_last_save', event.lastSaved)
                this.saveApplication()
                this.appFormFinished = false
                this.appFormUserControlModal.visible = true
                this.appFormUserControlModal.data = event
                this.appFormUserControlModal.stage = "started"
                this.setEditLock(null)
            })
            .listen(".finished", (event) => {
                this.appFormUserControlModal.visible = true
                this.appFormUserControlModal.stage = "finished"
                this.appFormUserControlModal.data = event
                this.appFormFinished = true
            })
            .listen(".continue", (event) => {
                _.set(this.initAppData, 'fast_track_active', event.fastTrackActive)
                _.set(this.initAppData, 'fast_track_last_save', event.lastSaved)
                this.appFormFinished = !event.continueForm
            })
            .listen(".save", (event) => {
                _.set(this.initAppData, 'fast_track_last_save', event.lastSaved)
            })

        this.$bus.$on("open-app-footer", (data) => {
            this.currentComponent(data, data.id)
            console.log("open-app-footer", data, data.id)
        })

        if (_.get(Ambition.Globals.tenant.user, "user_settings.application.footerComponents")) {
            this.sortingArray = _.get(Ambition.Globals.tenant.user, "user_settings.application.footerComponents")
            this.sorted()
        }

        this.getLoanApprovedApplicant()
        this.$bus.$on("refresh-loan-approved-applicant", (data) => {
            this.getLoanApprovedApplicant()
        })
        this.getCloseReasons()
        this.showDocumentGenerator = process.env.MIX_DOCUMENT_GENERATOR == "true"

        this.$bus.$on("saveApplication:enabled", (enabled) => {
            this.buttonDisabled = !enabled
            this.buttonText = this.forceButtonDisabled ? "Completed" : "Save Now"
        })

        this.$bus.$on("saveApplication:start", () => {
            this.buttonDisabled = true
            this.saving = true
            this.buttonText = this.forceButtonDisabled ? "Completed" : "Saving"
        })

        this.$bus.$on("saveApplication:end", () => {
            this.buttonDisabled = true
            this.saving = false
            this.buttonText = this.forceButtonDisabled ? "Completed" : "Save Now"
        })
    },
    beforeDestroy() {
        this.$bus.$off("saveApplication:enabled")
        this.$bus.$off("saveApplication:start")
        this.$bus.$off("saveApplication:end")
        this.$bus.$off("refresh-loan-approved-applicant")
        this.$bus.$off("open-app-footer")
        this.$bus.$off("update-is-ref-app-submitted")

        Echo.leave(`app-form.${Ambition.tenantId()}.${this.application.id}`)
    },
    created() {
        this.$bus.$on("pdf::close::merge", this.close)
        this.$bus.$on("refresh-loan-approved-applicant", (data) => {
            this.getLoanApprovedApplicant()
        })
        this.$bus.$on("footer::toolbar::component::open", (name) => {
            let item = this.items.findIndex((i) => {
                return i.text == name
            })

            if (item == "-1") {
                console.error("Please call the component using the text property as key")
            } else {
                this.currentComponent(this.items[item], item)
            }
        })

        this.$bus.$on("saveApplication:end", () => {
            this.buttonDisabled = true
            this.saving = false
            this.buttonText = this.forceButtonDisabled ? "Completed" : "Save Now"
        })
    },
    computed: {
        ...mapGetters({
            financeDetails: "summary/financeDetails",
            editLockUser: "editLockUser",
            initAppData: "initAppData",
        }),

        appCompleted: function () {
            return this.$store.getters.initAppData.application_status_id == 15
        },

        canEditCompleted: function () {
            return !!this.$store.getters.canEditCompleted
        },

        currentEditUser() {
            if (this.initAppData.fast_track_active) {
                let currentAppFormName = _.startCase(_.camelCase(this.application.fast_track_form))
                return this.application.applicants[0].full_name + " via " + currentAppFormName + " Application"
            } else if (!this.editLockUser) {
                return "No One"
            }

            let isSuperUser = Ambition.hasRoleOrPermission("super administrator", this.editLockUser)
            return (
                (isSuperUser ? "Fintelligence Support - " : "") + this.editLockUser.first_name + " " + this.editLockUser.last_name
            )
        },

        editorOnline: function () {
            return this.$store.getters["statusIndicators/usersViewingApp"].find(
                (x) => x.id == _.get(this.$store.getters, "editLock")
            )
        },
        thisStatus() {
            return this.$store.getters.initAppData.status
        },
        openStatus() {
            return this.$store.getters.initAppData.status === 3 ? false : true
        },
        stageIndex() {
            return this.$store.getters.initAppData.application_status_id - 1
        },
        thisStage() {
            return this.statuses.find((e, i) => e.index === this.stageIndex)
        },
        nextStage() {
            return this.statuses.find((e, i) => e.index === this.stageIndex + 1)
        },
        brokerLabel: function () {
            let broker = this.$store.getters["options/brokers"].find((x) => x.value == (this.$store.getters.broker_id || ""))
            return broker ? broker.label : ""
        },
        teamName() {
            return _.get(Ambition.Globals, "tenant.teams_enabled", false)
                ? _.get(this.$store.getters.initAppData, "team.name", "No Team")
                : null
        },
        referenceData() {
            return [
                { label: "App #", value: this.application.ref_id },
                { label: "Assigned To", value: this.brokerLabel },
                { label: "Applicant", value: `${this.applicantInfo.first_name} ${this.applicantInfo.last_name}` },
                { label: "Amount", value: `$${this.application.amount_to_financed || "0"}` },
            ]
        },
        canControlApp() {

            if (_.get(this.initAppData, 'fast_track_active')) return false

            // allow control if not enabled
            if (!_.get(this.Ambition.Globals.tenant, "editLockEnabled")) return true

            // lock until user id populates
            if (!_.get(this.Ambition.Globals.tenant.user, "id")) return false

            // if no lock is in place and the user is the broker allow control
            if (
                !_.get(this.$store.getters, "editLock") &&
                _.get(this.Ambition.Globals.tenant.user, "id") == _.get(this.$store.getters, "broker_id") &&
                !this.application.fast_track_active
            )
                return true

            // lock if no lock in place to force take control
            if (!_.get(this.$store.getters, "editLock")) return false

            // if a lock is in place unlock if the user has the lock
            if (_.get(this.Ambition.Globals.tenant.user, "id") == _.get(this.$store.getters, "editLock")) return true

            // if app completed and no edit completed permission, ignore take control
            if (this.appCompleted && this.canEditCompleted) return true

            // lock everyone else
            return false
        },
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            }
        },
    },
    methods: {
        allowTakeControl() {
            this.appFormFinished = true
        },
        confirmAppFormAction() {
            this.appFormUserControlModal.visible = false
            if (['finished', 'timed out'].includes(this.appFormUserControlModal.stage)) {
                window.onbeforeunload = null
                window.location.reload()
            }
        },
        confirmAppFormTakeover() {
            this.takeControlAppFormModal.visible = false
            this.$tenant.post(`/api/applications/${this.$store.getters.appId}/app-form-broker-takeover`).then(res => {
                window.onbeforeunload = null
                window.location.reload()
            })
        },
        onDragEnd() {
            let newSortingArray = this.items.map((item, index) => ({ id: item.id, order: index }))
            this.$tenant
                .put("/api/v2/user-settings", { application: { footerComponents: newSortingArray } })
                .then((res) => {
                    this.sortingArray = newSortingArray
                })
                .catch((err) => {
                    err.output()
                })
                .finally(() => {
                    this.sorted()
                })
        },
        getLoanApprovedApplicant() {
            axios
                .get("/admin/application/" + this.application.id + "/get-loan-approved-applicant")
                .then((res) => {
                    this.applicantInfo = res.data
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        sorted() {
            this.items = this.items.sort((a, b) => {
                return (
                    _.get(_.find(this.sortingArray, { id: a.id }), "order") -
                    _.get(_.find(this.sortingArray, { id: b.id }), "order")
                )
            })
        },
        closeApplicationModalOpen() {
            if (this.appCompleted && !this.canEditCompleted) return

            if (Ambition.useEmailBuilder()) {
                this.closeApplicationModalVisibility = true
            } else {
                this.closeModal = true
            }
        },
        headers() {
            let headers = {
                headers: { Authorization: "Bearer " + this.$store.getters.token },
            }

            return headers
        },
        checkReasonSelected() {
            // check to see if a reason is selected before
            this.awaitingCloseReason = true
            if (this.closeReason !== "") {
                this.awaitingCloseReason = false
            }
        },
        async closeApplication() {
            // stop if a reason hasn't been selected
            if (this.closeReason === "") {
                return
            }
            this.closeAppSubmitted = true
            this.$store.getters.initAppData.status = 3
            let headers = {
                headers: { Authorization: "Bearer " + this.$store.getters.token },
            }

            let data = {
                _method: "DELETE",
                close_reason: this.closeReason,
            }

            await axios.post("/admin/applications/" + this.application.id, data, headers).then((res) => {
                this.closeAppSubmitted = false
                this.closeModal = false
                this.$store.dispatch("updateAppStatus", 3)
                const hasAppOpenedWindow = window.opener
                if (hasAppOpenedWindow) {
                    swal({
                        title: "Application Closed",
                        text: "Would you like to close this tab or return to all applications?",
                        type: "success",
                        showCancelButton: true,
                        cancelButtonText: "Close Tab",
                        cancelButtonColor: "#909399",
                        confirmButtonText: "All Applications",
                        confirmButtonColor: "#5cbb2a",
                    }).then((result) => {
                        if (result.value) {
                            window.onbeforeunload = null
                            window.location.href = "/admin/applications"
                        } else {
                            window.onbeforeunload = null
                            window.open("", "_self", "").close()
                        }
                    })
                } else {
                    window.onbeforeunload = null
                    window.location.href = "/admin/applications"
                }
            })
        },
        getCloseReasons() {
            let headers = {
                headers: { Authorization: "Bearer " + this.$store.getters.token },
            }
            axios.get("/api/close-reasons", headers).then((res) => {
                this.closeReasonsOptions = this.formatOptions(res.data)
            })
        },
        formatOptions(data) {
            let options = []

            data.map((element) => {
                options.push({ label: element.name, value: element.id })
            })

            return options
        },
        close() {
            this.show = false
            this.currentTabComponent = ""
            this.active = null
        },
        fullscreen() {
            this.showFullscreen = !this.showFullscreen
        },
        currentComponent(item, id) {
            if (this.active == id) {
                this.active = null
                this.show = false
            } else if (item.title === "Video Chat") {
                this.active = null
                this.show = false
                window.open(`/admin/applications/${this.application.id}/tenant-video-chat`, "_blank")
            } else {
                this.show = true
                this.currentTabComponent = item.component
                this.currentTabProps = item.props ? item.props : ""
                this.active = this.active == id ? null : id

                if (this.show) {
                    localStorage.removeItem("openFooterTab")
                }
            }
        },
        currentStageName() {
            return $("#tabs-panel a").not(".tab-nav-completed").first().attr("title")
        },
        reopen() {
            axios.get("/api/applications/" + this.application.id + "/reopen", this.headers).then((res) => {
                this.$store.getters.initAppData.status = res.data.status
            })
        },

        // Trigger save now on active tab (@see ApplicationSaveButtonComponent.vue)
        saveApplication() {
            if (this.disableSave || this.saving) return
            this.saving = true
            this.buttonText = "Saving"
            this.$bus.$emit("saveApplication")
        },

        takeControl() {
            if (this.initAppData.fast_track_active) {
                this.takeControlAppFormModal.visible = true
            } else {
                this.confirmTakeControl()
            }
        },

        confirmTakeControl() {
            if (this.editorOnline) {
                this.$bus.$emit("requestControl", { user: this.Ambition.Globals.tenant.user })
                _.set(this.initAppData, 'fast_track_active', null)
            } else {
                this.setEditLock(_.get(this.Ambition.Globals.tenant.user, "id")).then(() => {
                    this.$message({
                        type: "success",
                        message: "Edit Mode Activated",
                    })
                    _.set(this.initAppData, 'fast_track_active', null)
                })
            }
        },

        async setEditLock(id) {
            let headers = { headers: { Authorization: "Bearer " + this.$store.getters.token } }
            let url = "/api/application/" + this.$store.getters.initAppData.id
            let data = { update_edit_lock: true, edit_lock: id }

            let res
            try {
                res = await axios.patch(url, data, headers)
                this.$store.dispatch("updateEditLock", id)
                this.$store.dispatch("updateEditLockUser", _.get(res.data, 'user', null))
            } catch (e) {
                throw e
            }
        },
    },

    watch: {
        appCompleted: {
            handler(appCompleted) {
                if (appCompleted) {
                    this.forceButtonDisabled = !this.canEditCompleted
                    this.saving = false
                } else {
                    this.forceButtonDisabled = false
                    this.saving = false
                }
            },
            pendingSave: {
                handler(pending) {
                    this.$bus.$emit("saveApplication:enabled", pending)
                },
                immediate: true,
                deep: true,
            },
        },
    },
}
</script>
<style lang="scss" scoped>
.app-ref {
    display: none;
    @media (min-width: 1620px) {
    }

    @media (min-width: 1340px) {
        display: inline-block;
    }

    @media (min-width: 1540px) {
        display: inline-block;
    }
}
</style>

<style lang="scss">
.footer-app-ref-tooltip {
    .tooltip-inner {
        max-width: none; // width: 400px;
        white-space: nowrap;
        padding: 15px;
    }
}
</style>

<style lang="scss" scoped>
.badge-wait,
.badge-ambition.is-disabled {
    background: grey !important;
    border: 1px solid grey !important;
}

.badge-ambition {
    background: #2493ef !important;
    border: 1px solid #2493ef !important;
}
</style>
